export default __webpack_public_path__ + "static/media/product3.33cc08dd.jpeg";